import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

/* Core services */
import { SimpleNotificationsModule, NotificationsService } from 'angular2-notifications';

import { ClientApiService } from './api/api.service';
import { AuthService } from './auth/auth.service';
import { FileService } from './helpers/file.service';
import { ApiInterceptorService } from './api/api-interceptor.service';
import { WebsiteTogglerService } from '../dashboard/components/websites-toggler/services/website-toggler.service';
import { LocalStorageModule } from 'angular-2-local-storage';
import { LoadingIndicatorService } from './helpers/loading-indicator.service';
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    LocalStorageModule.withConfig({
      prefix: 'adsperience',
      storageType: 'localStorage'
    }),
    SimpleNotificationsModule,
  ],
  exports: [
    BrowserAnimationsModule,
    SimpleNotificationsModule,
    LoadingBarComponent
  ],
  declarations: [LoadingBarComponent],
  providers: [
    ClientApiService,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptorService,
      multi: true
    },
    FileService,
    LoadingIndicatorService,
    NotificationsService,
    WebsiteTogglerService
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
  static forRoot(config: ModuleWithProviders): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: []
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts